// extracted by mini-css-extract-plugin
export var cite = "RichTextReview-module--cite--8062e";
export var content = "RichTextReview-module--content--2d97c";
export var placementGrid = "RichTextReview-module--placementGrid--63d4e";
export var placementRichtext = "RichTextReview-module--placementRichtext--7b0bd";
export var root = "RichTextReview-module--root--94c3c";
export var title = "RichTextReview-module--title--8cc16";
export var variant = "RichTextReview-module--variant--ba94b";